"use strict";
/* This is the full spec of the JSON structure supported by the logger. See README.md for details of each
field. */
Object.defineProperty(exports, "__esModule", { value: true });
const fields = [
    "source",
    "timestamp",
    "level",
    "message",
    "stack",
    "context",
    "type",
    "userid",
    "id",
    "custom",
    "logRocketUrl",
    "userCookies",
    // http error fields
    "remoteAddr",
    "url",
    "contentLength",
    "referrer",
    "method",
    "url",
    "userAgent",
    "remoteUser",
    "status",
    "userId",
    "activityId",
    "routeTemplate",
    "payload",
    "durationSecs",
    "upstreamDurationSecs",
    "upstreamRoutes",
    "referer",
    "productCookies",
    "sessionCookies",
    "hasAuthCookie",
    "legacySessionExpiration",
    "contactId",
    "correlationId",
    "requestId",
    "pid",
    "ppid",
    "messageJson",
    "dd",
    "otel",
    "eventTypeName",
    "serviceName",
    "data",
    "eventSource",
];
function mapper(obj) {
    return getAllProps(obj)
        .filter((p) => fields.filter((f) => f === p).length)
        .reduce((cleansed, name) => 
    // make sure we only have properties where they have a non-null value
    obj[name] !== null
        ? Object.assign(cleansed, { [name]: obj[name] })
        : cleansed, {});
}
function getAllProps(obj) {
    var props = Object.getOwnPropertyNames(obj);
    var parentProto = Object.getPrototypeOf(obj);
    if (parentProto !== Object.prototype) {
        props = [...props, ...getAllProps(parentProto)];
    }
    return props;
}
class JsonFormatter {
    format(obj) {
        return JSON.stringify(mapper(obj));
    }
}
exports.default = JsonFormatter;
//# sourceMappingURL=json.js.map